import { getText } from "shared/lib";
import { type TreeDescriptor } from "@/components/treeModule/lib";

import { Dialog, DialogContent, DialogTitle } from "shared/components";
import { SingleStemCircumferenceContent } from "@/components/treeModule/treeMeasurementsHelp/SingleStemCircumferenceContent";

export interface SingleStemCircumferenceDialogProps {
  onOpenChange: (open: boolean) => void;
  open: boolean;
  treeDescriptor: TreeDescriptor | undefined | null;
}

export function SingleStemCircumferenceDialog({
  onOpenChange,
  open,
  treeDescriptor,
}: SingleStemCircumferenceDialogProps) {
  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent className="max-h-[95vh] !max-w-[600px] overflow-auto">
        <DialogTitle>
          {getText("How to measure a single stem tree")}
        </DialogTitle>

        <SingleStemCircumferenceContent treeDescriptor={treeDescriptor} />
      </DialogContent>
    </Dialog>
  );
}
